import { Button } from '@com/_atoms/NewButton';
import NextImage from '@com/_core/NextImage';
import ActionBar from '@com/Layout/ActionBar';
import { Bottomsheet } from '@com/modal/containers/Bottomsheet';
import { colorPallete } from '@configs/color-pallete';
import { MESSAGES } from '@models/ocs/schedule';
import Icon from '@utilities/icon';
import useModal from '@hooks/useModal';

const TariffBottomSheet = () => {
  const { removeLastModal } = useModal();
  return (
    <Bottomsheet
      height={'auto'}
      hasCloseButton
      className="min-h-[388px] flex flex-col max-h-[calc(100vh-50px)]"
      titleClassName="border-b"
      title={MESSAGES.Lower_than_the_tariff}
    >
      <div className="flex flex-col gap-y-4 p-4">
        <NextImage
          src="/images/ocs/images/lowerThanTheTariff.png"
          className="m-auto"
          alt="tariff"
          width={200}
          height={200}
        />
        <p className="text-Body/Small text-content-tertiary">
          با افزایش ۵۵ درصدی خدمات درمانی از ابتدای ۱۴۰۵، مشاوره آنلاین پزشکی و
          روانشناسی را نزد ما می‌توانید تا ۲۵ درصد کمتر از تعرفه مصوب دریافت
          کنید.
          <a
            target="_blank"
            className="flex text-Body/Medium text-content-accent"
            href="https://blog.tapsi.doctor/doctors-visits-in-1405/"
          >
            بیشتر بدانید
            <Icon
              name="CircleInformation"
              width={1.3}
              height={1.3}
              fill={colorPallete.surface.accent}
            />
          </a>
        </p>
      </div>
      <ActionBar type="singleAction" hasDivider>
        <Button
          variant="secondary"
          className="w-full"
          onClick={removeLastModal}
        >
          متوجه شدم
        </Button>
      </ActionBar>
    </Bottomsheet>
  );
};

export default TariffBottomSheet;
